<div class="login-container">
  <div class="login-form">
    <h2>Login</h2>
    <form @submit.prevent="login">
      <input v-model="email" type="email" placeholder="Email" required>
      <input v-model="password" type="password" placeholder="Password" required>
      <button type="submit">Submit</button>
    </form>
    <p>Don't have an account? <a href="mailto:david@syncallai.com">Contact Us</a></p>
  </div>
</div>
